<!-- 供应商信息table -->
<template>
    <el-table border :header-cell-style="{
        backgroundColor: '#FDEFE7', color: '#000000'
    }" :data="tableData" style="width: 100%">
        <el-table-column fixed="left" align="center" prop="stockCompanyId" label="供应商" width="180">
        </el-table-column>
        <el-table-column align="center" prop="stockCompanyName" label="供应商名称">
        </el-table-column>
        <el-table-column align="center" prop="address" label="总订单数及金额" width="180">
            <template slot-scope="scope">
                <p>子订单数：<span style="color: red;">{{ scope.row.childrenOrderNumber  }}</span></p>
                <p>金额：<span>¥{{ scope.row.price  }}</span></p>
            </template>
        </el-table-column>
        <el-table-column align="center" prop="name" label="待确认子订单数及金额">
            <template slot-scope="scope">
                <p>总订单数：<span style="color: red;">{{ scope.row.toBeConfirmedNumber  }}</span></p>
                <p>金额：<span>¥{{ scope.row.toBeConfirmedPrice  }}</span></p>
            </template>
        </el-table-column>
        <el-table-column align="center" prop="name" label="操作时间报警" width="180">
        </el-table-column>
<!--        <el-table-column align="center" prop="name" label="操作" width="180">-->
<!--            <el-button type="danger" icon="el-icon-delete" circle></el-button>-->
<!--        </el-table-column>-->
    </el-table>
</template>
<script>
import OrderApi from '@/components/Api/order'
export default {
    props: {
        orderId: {
            type: String,
            default: ''
        }
    },
    components: {},
    data() {
        return {
            tableData: [],
        }
    },
    computed: {},
    watch: {},
    methods: {
        //获取供应商信息
        getSupplierInformation() {
            new OrderApi("order")
                .supplierInformation(this.orderId)
                .then((res) => {
                    if (res.status == 200) {
                        this.tableData = res.data
                    } else {
                        this.$message.error({ message: res.statusText });
                    }
                });
        }
    },
    created() {

    },
    mounted() {
        this.getSupplierInformation()
    },
}
</script>
<style lang='scss' scoped></style>